import React from 'react';

import { Link } from '@mui/material';
import { PartnerPortalInfo } from './PartnerPortalInfo';

import { PARTNERSHIP_TIERS, SCHEDULE_DATA, FREE_TRIAL } from '../../constants/Pages/PartnerWithUs';

import './PartnershipTierInfo.css';

export const PartnershipTierInfo = ({ TierInfo }) => {
  return (
    <div>
      {TierInfo === FREE_TRIAL && (
        <div>
          <Link
            variant="body2"
            underline="none"
            href="https://drive.google.com/file/d/1y0j8Y4rnK9KP10fxGeZtUPyosanP8zek/view?usp=sharing"
            color="black"
            target="_"
          >
            View Sample
          </Link>
        </div>
      )}
      {Object.keys(PARTNERSHIP_TIERS[TierInfo]).map((scheduled_data) => {
        if (scheduled_data === SCHEDULE_DATA) {
          return (
            <p className="partnership-tier-info-row-description">
              {SCHEDULE_DATA + ' ' + PARTNERSHIP_TIERS[TierInfo][SCHEDULE_DATA]}
            </p>
          );
        }

        if (scheduled_data === 'PartnerHub') {
          return (
            <PartnerPortalInfo PartnerPortalInfo={PARTNERSHIP_TIERS[TierInfo][scheduled_data]} />
          );
        }
      })}
    </div>
  );
};
